<!--
  --
  -- 免許証の種類入力コンポーネント
  --
  -->
<template>
  <c-input
    class="c-license-type"
    :label="label"
    :value="value"
    :rules="rules"
  >
    <div class="mt-2">
      <c-item-group
        v-model="limited"
        :items="limitedItem"
      />
      <c-item-group
        class="mt-1"
        v-model="types"
        :items="typeItems"
      />
    </div>
  </c-input>
</template>

<script>
import CInput from '../CInput'
import CItemGroup from './CItemGroup'

export default {
  name: 'CLicenseType',
  components: {
    CInput,
    CItemGroup
  },

  // v-model の定義
  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    // ラベル
    label: {
      type: String
    },

    // 値
    value: {
      type: String
    },

    // 入力チェックルール
    rules: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    // 限定, 種類の入力値
    limited: [],
    types: [],

    // 限定, 種類選択肢
    limitedItem: LIMITED_ITEMS,
    typeItems: TYPE_ITEMS
  }),

  computed: {
    /**
     * change イベントで返す免許証種類文字列
     */
    typeText () {
      const types = [
        0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0,
        0, 0, 0
      ]
      this.limited.forEach(index => (types[index] = 1))
      this.types.forEach(index => (types[index] = 1))
      return types.join('')
    }
  },

  watch: {
    // value プロパティが変化したら、reactValue() で limited, types を更新する
    value: {
      immediate: true,
      handler: 'reactValue'
    },

    // typeText が変化したら、change イベントを送出する
    typeText (newValue) {
      this.$emit('change', newValue)
    }
  },

  methods: {
    /**
     * 種類文字列から limited, types を更新する
     *
     * @param {String} value 種類文字列
     */
    reactValue (value) {
      const s = value || ''
      const limited = []
      const types = []

      // 免許の種類情報を得る
      for (let i = 0; i < 14; ++i) {
        if (s.charAt(i) === '1') {
          types.push(i)
        }
      }

      // 限定情報を得る
      for (let i = 14; i < 17; ++i) {
        if (s.charAt(i) === '1') {
          limited.push(i)
        }
      }

      this.limited = limited
      this.types = types
    }
  }
}

const LIMITED_ITEMS = [
  { label: 'ＡＴ限定', value: 14 },
  { label: '８ｔ限定', value: 15 },
  { label: '５ｔ限定', value: 16 }
]

const TYPE_ITEMS = [
  { label: '大型', value: 0 },
  { label: '中型', value: 1 },
  { label: '準中型', value: 2 },
  { label: '普通', value: 3 },
  { label: '大型特殊', value: 4 },
  { label: '大自ニ輪', value: 5 },
  { label: '普自ニ輪', value: 6 },
  { label: '小型特殊', value: 7 },
  { label: '原付', value: 8 },
  { label: '大型ニ種', value: 9 },
  { label: '中型ニ種', value: 10 },
  { label: '普通ニ種', value: 11 },
  { label: '大特ニ種', value: 12 },
  { label: 'けん引', value: 13 }
]
</script>
